import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-cte-educator-resources',
  imports: [PillarPagesTemp],
  templateUrl: './cte-educator-resources.html',
  styleUrl: './cte-educator-resources.scss',
})
export class CteEducatorResources {

}
